import config from 'app/config';
import { clientFetch } from 'utils/client-fetch';
import { PersonSearchRequest, PersonPaginatedResponse, RosterGroup } from './types';

export const searchPeople = (request: PersonSearchRequest): Promise<PersonPaginatedResponse> =>
    clientFetch({
        method: 'post',
        url: `${config.ROSTER_API_URL}/search`,
        body: request,
    });

export const listGroups = (): Promise<{ success: true; data: RosterGroup[] }> =>
    clientFetch({ url: `${config.ROSTER_API_URL}/groups` });
